import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import {
  List,
  ListItem,
  SvgIcon,
  Spinner
} from '../'

import {
  decodeBase64
} from '../../utils'

// this component lists files associated with an object.
// - the listing is displayed as hyperlinked items
// - displaying download icons with each item is optional
class ObjectFilesList extends React.Component {
  static propTypes = {
    objectUUID: PropTypes.object.isRequired,
    displayDownloadIcons: PropTypes.bool
  }

  generateFileLinkList = (fileRelations, displayDownloadIcons) => {
    let fileLinkListItems = fileRelations.map(({ node: fileRelation }, i) => (
      <ListItem key={fileRelation.file.id} className='slds-m-right_large'>
        {displayDownloadIcons
          ? <a href={fileRelation.file.url}>
              <div>
                <div className='slds-align_absolute-center'>
                  <SvgIcon
                    variant='utility'
                    symbol='download'
                    size='x-small'
                  />
                </div>
                {fileRelation.file.asset.length > 13
                  ? '[..]'+fileRelation.file.asset.slice(
                      fileRelation.file.asset.length-13,
                      fileRelation.file.asset.length
                    )
                  : fileRelation.file.asset
                }
              </div>
            </a>
          : <a href={fileRelation.file.url}>{fileRelation.file.asset}</a>
        }
      </ListItem>
    ))

    return fileLinkListItems
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />
    }

    if (this.props.data.error) {
      return <h1>Oh dear! We have an issue</h1>
    }

    if (this.props.data.filerelations.edges.length > 0) {
      let files = this.generateFileLinkList(
        this.props.data.filerelations.edges,
        this.props.displayDownloadIcons
      )
      return (
        <List items={files} className='slds-list_horizontal slds-wrap' />
      )
    } else {
      return null
    }
  }
}

const getFiles = gql`
  query($objectID: UUID) {
    filerelations(objectId: $objectID) {
      edges {
        node {
          ...FileRelation
        }
      }
    }
  }
  ${fragments.fileRelation}
`

const withData = graphql(getFiles, {
  options: ({ objectUUID }) => ({
    variables: {
      objectID: decodeBase64(objectUUID)
    }
  })
})

export default withData(ObjectFilesList)



// WEBPACK FOOTER //
// ./src/components/object-files-list/index.js